import useStyles from '../../../../../../styles/global-mui.js';
import { getMatchPlayers, getMatchTeams } from "../../../../../../components/Live/import/sondage/bdd/genericSondage.js";
import { v4 as uuidv4 } from 'uuid';
import { SelectPlayerOrdered } from "../../components/SelectPlayerOrdered.js";
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import DsasButton from '../../../../../components/DsasButton/DsasButton.js';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

const entryTypes = [
    {value : 'player', label : 'Joueur'}, 
    {value : 'team', label : 'Equipe'}, 
    {value : 'txt', label : 'Texte'}
  ]

const SelectQuizzChoices = ({event, directEvent, onChange}) => {

    const handleChangeLabel = (choiceIndex, value) => {
    const newChoices = event.choices.map((c, i) =>
        i === choiceIndex ? { ...c, label: value } : c
    );
    onChange('choices', newChoices);
    };

    const handleChangeEntryType = (choiceIndex, entryIndex, type) => {
    const newChoices = event.choices.map((c, i) => {
        if (i !== choiceIndex) return c;
        const newEntries = c.entries.map((en, j) => {
        if (j !== entryIndex) return en;
        return {
            ...en,
            type,
            id: type === 'player' ? undefined : uuidv4(),
            // on peut aussi reset le name pour éviter des incohérences
            name: type === 'txt' ? '' : en.name ?? ''
        };
        });
        return { ...c, entries: newEntries };
    });
    onChange('choices', newChoices);
    };

    const handleChangeEntry = (choiceIndex, entryIndex, value) => {
    const newChoices = event.choices.map((c, i) => {
        if (i !== choiceIndex) return c;
        const newEntries = c.entries.map((en, j) => {
        if (j !== entryIndex) return en;

        if (en.type === 'txt') {
            return { ...en, name: value };
        }
        if (en.type === 'player') {
            const p = getMatchPlayers(directEvent)?.find(p => p._id === value);
            return { ...en, id: value, name: p?.lastname ?? '' };
        }
        if (en.type === 'team') {
            const t = getMatchTeams(directEvent)?.find(t => t._id === value);
            return { ...en, id: value, name: t?.name ?? '' };
        }
        return en;
        });
        return { ...c, entries: newEntries };
    });
    onChange('choices', newChoices);
    };

    // coche "Bonne réponse"
    const handleChangeEntryCorrect = (choiceIndex, entryIndex, isChecked) => {
    const isMultiple = !!event.options?.multipleChoice;

    const newChoices = event.choices.map((c, i) => {
        if (i !== choiceIndex) return c;

        let newEntries;
        if (isMultiple) {
        // on toggle indépendamment
        newEntries = c.entries.map((en, j) =>
            j === entryIndex ? { ...en, isCorrect: isChecked } : en
        );
        } else {
        // une seule bonne réponse : on met tout à false, puis celle cliquée à true
        newEntries = c.entries.map((en, j) => ({
            ...en,
            isCorrect: j === entryIndex ? isChecked : false
        }));
        }

        return { ...c, entries: newEntries };
    });

    onChange('choices', newChoices);
    };

    const handleRemoveEntry = (choiceIndex, entryIndex) => {
    const newChoices = event.choices.map((c, i) => {
        if (i !== choiceIndex) return c;
        return {
        ...c,
        entries: c.entries.filter((_, j) => j !== entryIndex)
        };
    });
    onChange('choices', newChoices);
    };

    const handleAddEntry = (choiceIndex) => {
    const last = event.choices[choiceIndex].entries.at(-1);
    const type = last?.type ?? 'txt';
    const added = { id: type === 'player' ? undefined : uuidv4(), name: '', type };

    const newChoices = event.choices.map((c, i) => {
        if (i !== choiceIndex) return c;
        return { ...c, entries: [...c.entries, added] };
    });

    onChange('choices', newChoices);
    };

    const handleAddChoice = () => {
    let newChoice;
    if (event.choices.length > 0) {
        const lastChoice = event.choices.at(-1);
        if ((lastChoice.entries?.length ?? 0) <= 1) {
        const base = lastChoice.entries?.[0] ?? { type: 'txt' };
        newChoice = {
            label: '',
            entries: [{
            ...base,
            id: base.type === 'player' ? undefined : uuidv4(),
            name: '',
            isCorrect: false
            }]
        };
        } else {
        newChoice = {
            label: '',
            entries: lastChoice.entries.map(e => ({
            ...e,
            id: e.type === 'player' ? undefined : uuidv4(),
            name: '',
            isCorrect: false
            }))
        };
        }
    } else {
        newChoice = { label: '', entries: [{ id: uuidv4(), type: 'txt', name: '', isCorrect: false }] };
    }

    onChange('choices', [...event.choices, newChoice]);
    };

    const handleRemoveChoice = (index) => {
    onChange('choices', event.choices.filter((_, i) => i !== index));
    };

    const classes = useStyles();

    return (
        <Box className="survey-form-choices small-padding">
            <Box className='centered-wrapper'>
                <Typography variant='body1' fontWeight="bold" gutterBottom>Choix</Typography>
            </Box>

            <Box>
                {event.choices.map((choice, choiceIndex) => (
                    <React.Fragment key={choiceIndex}>
                    <Box className="survey-form-choice small-padding" key={choiceIndex}>
                        {choice.entries.length > 1 &&
                        <>
                            <TextField
                                type="text"
                                size="small"
                                label="Libellé"
                                placeholder="Saisir le label..."
                                multiline //permet d'afficher plusieurs lignes
                                minRows={1} //Hauteur de base
                                maxRows={4} //Hauteur maximale avant scroll interne
                                className={`input-field ${classes.customInput}`}
                                value={choice.label}
                                onChange={(e) => handleChangeLabel(choiceIndex, e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />
                            <Box className='small-padding'></Box>
                            </>
                        }
                        <Box className="survey-form-entries">
                            {choice.entries.map((entry, entryIndex) => (
                                <Box className="survey-form-entry" key={entryIndex}>

                                    <Grid container spacing={1} sx={{alignItems: 'center', textAlign:'center'}}>
                                        {directEvent.type !== 'actu' &&  
                                        <Grid item xs={12} sm={4} md={12} lg={4}>
                                            {/**CHOICE TYPE SELECTION*/}
                                            <FormControl fullWidth size="small" className={classes.customInput}> {/* facultatif mais recommandé pour un layout propre */}
                                                <InputLabel id={`entry-type-label-${choiceIndex}-${entryIndex}`}>Type</InputLabel>
                                                <Select
                                                    labelId={`entry-type-label-${choiceIndex}-${entryIndex}`}
                                                    value={entry.type}
                                                    label="Type"
                                                    onChange={(e) =>
                                                    handleChangeEntryType(choiceIndex, entryIndex, e.target.value)
                                                    }
                                                >
                                                    {entryTypes.map((entryType) => (
                                                    <MenuItem key={entryType.value} value={entryType.value}>
                                                        {entryType.label}
                                                    </MenuItem>
                                                    ))}
                                                </Select>
                                                </FormControl>
                                        </Grid>
                                        }

                                        <Grid item xs={12} 
                                            sm={directEvent.type !== 'actu' ? 8 : 12} 
                                            md={12} 
                                            lg={directEvent.type !== 'actu' ? 8 : 12}>
                                            {entry.type==='txt' ?
                                            <TextField
                                                type="text"
                                                size="small"
                                                multiline //permet d'afficher plusieurs lignes
                                                minRows={1} //Hauteur de base
                                                maxRows={4} //Hauteur maximale avant scroll interne
                                                // auto-width-input
                                                className={`input-field ${classes.customInput}`}
                                                placeholder="Saisir le label..."
                                                value={entry.name}
                                                onChange={(e) => handleChangeEntry(choiceIndex, entryIndex, e.target.value)}
                                                // sx={{ width: `${entry.name.length + 1}ch` }} // Ajustement dynamique
                                                fullWidth
                                                sx={{
                                                    '& .MuiInputBase-root textarea': {
                                                    textAlign: 'center', // ✅ centre le texte et le placeholder
                                                    }
                                                }}
                                            />
                                            :
                                            entry.type === 'player' ?  //Comme entry.id est un uuid généré automatiquement, ça pose soucis car c'est pas un id de joueur à l'initialisation
                                                <SelectPlayerOrdered match={directEvent} value={entry.id} onChange={(value) => handleChangeEntry(choiceIndex, entryIndex, value)} />
                                                : (
                                                <FormControl fullWidth size="small" className={classes.customInput}>
                                                    <InputLabel id={`entry-team-label-${choiceIndex}-${entryIndex}`}>Équipe</InputLabel>
                                                    <Select
                                                        labelId={`entry-team-label-${choiceIndex}-${entryIndex}`}
                                                        value={entry.id}
                                                        label="Équipe"
                                                        onChange={(e) =>
                                                        handleChangeEntry(choiceIndex, entryIndex, e.target.value)
                                                        }
                                                    >
                                                        <MenuItem value="">
                                                        <em>Sélectionner une équipe</em>
                                                        </MenuItem>
                                                        {getMatchTeams(directEvent).map((team) => (
                                                        <MenuItem key={team._id} value={team._id}>
                                                            {team.name}
                                                        </MenuItem>
                                                        ))}
                                                    </Select>
                                                    </FormControl>
                                                    )}
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Box className='centered-wrapper' sx={{pb:1}}>
                                                <InputLabel className={classes.customInputLabel}>Bonne réponse</InputLabel>
                                                {/* <input type="checkbox" label="Bonne réponse" checked={entry.isCorrect} onChange={(e) => handleChangeEntryCorrect(choiceIndex, entryIndex, e.target.checked)}/> */}
                                                <input
                                                    label="Bonne réponse"
                                                    type="checkbox"
                                                    checked={!!entry.isCorrect}
                                                    onChange={(e) => handleChangeEntryCorrect(choiceIndex, entryIndex, e.target.checked)}
                                                    />
                                            </Box>
                                            {choice.entries.length > 1 && (
                                                <Box className='centered-wrapper'>
                                                    <DsasButton
                                                        customCss={{}} 
                                                        label={`Suppr. section`} 
                                                        variant = 'secondarysub'
                                                        icon={faMinus}
                                                        onClick={() => handleRemoveEntry(choiceIndex, entryIndex)}
                                                    >
                                                    </DsasButton>
                                                </Box>
                                            )}

                                           {/* {entryIndex === choice.entries.length - 1 && ( */}
                                        </Grid>
                                    </Grid>
                                    
                                    <Box className='small-padding'></Box>
                                    <Box className='large-separator'></Box>
                                    <Box className='small-padding'></Box>
                                </Box>
                            ))}
                        </Box>
                         {/* {entryIndex === choice.entries.length - 1 && ( */}
                         <Box className='small-padding' sx={{paddingLeft:'4px'}}>
                                                <DsasButton
                                                    customCss={{}} 
                                                    label={`Ajouter section`} 
                                                    variant = 'secondarysub'
                                                    icon={faPlus}
                                                    onClick={() => handleAddEntry(choiceIndex)}
                                                >
                                                </DsasButton>
                                             {/* )} */}
                        </Box>
                        <DsasButton
                            customCss={{fontSize:'0.85rem', marginLeft:0, marginRight:0}} 
                            label={`Supprimer le choix`} 
                            variant = 'secondary'
                            customClassname='smaller'
                            icon={faTrashCan}
                            onClick={() => handleRemoveChoice(choiceIndex)}
                        >
                        </DsasButton>
                    </Box>
                    <Box className='large-separator'></Box>
                    <Box className='large-separator'></Box>
                    <Box className='small-padding'></Box>
                    </React.Fragment>
                    
                ))}
            </Box>

             <Box className='centered-wrapper'>
                <DsasButton
                    customCss={{marginLeft:0, marginRight:0, marginBottom:0}} 
                    label={`Ajouter un choix`} 
                    variant = 'secondary'
                    icon={faPlus}
                    onClick={handleAddChoice}
                ></DsasButton>
            </Box>            
        </Box>
    )
}

export default SelectQuizzChoices